import { render, staticRenderFns } from "./milestoneTable.vue?vue&type=template&id=d8f99b86&scoped=true"
import script from "./milestoneTable.vue?vue&type=script&lang=ts"
export * from "./milestoneTable.vue?vue&type=script&lang=ts"
import style0 from "./milestoneTable.vue?vue&type=style&index=0&id=d8f99b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f99b86",
  null
  
)

export default component.exports